const atwRouter = [
  {
      path: "list-atw",
      name: "atw",
      component: () => import("@/views/admin/atw"),
      default: true,
      meta: {
          model: "atw",
          // requiresAuth: true,
      },
  },
  {
      path: "list-atw/add",
      name: "addAtw",
      component: () => import("@/views/admin/atw/function"),
      default: true,
      meta: {
          model: "atw",
          // requiresAuth: true,
      },
  },
  {
      path: "list-atw/edit/:id",
      name: "editAtw",
      component: () => import("@/views/admin/atw/function"),
      default: true,
      meta: {
          model: "atw",
          // requiresAuth: true,
      },
  },
  {
    path: "list-atw/view/:id",
    name: "detailAtw",
    component: () => import("@/views/admin/atw/view"),
    default: true,
    meta: {
        model: "atw",
        // requiresAuth: true,
    },
  },
  {
    path: "list-atw/detail/:id",
    name: "detailAtw",
    component: () => import("@/views/admin/atw/detail"),
    default: true,
    meta: {
        model: "atw",
        // requiresAuth: true,
    },
  },
]
export default atwRouter;